export const createFileUploadSlice = set => ({
	openReportUpload: false,
	filesToUpload: [],
	studyInfo: null,

	setOpenReportUpload: open => set({ openReportUpload: open }),
	setFilesToUpload: files => set({ filesToUpload: files }),
	setStudyInfo: info => set({ studyInfo: info }),

	resetFileUploadStore: () =>
		set({
			openReportUpload: false,
			filesToUpload: [],
			studyInfo: null,
		}),
});
